import {
  Clock,
  User,
  Smartphone,
  ShoppingCart,
  DollarSign,
  TrendingDown,
  UserCog,
} from "lucide-react"
import { activityLogs } from "../../data/mock"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getActivitiesData } from "../../store/actions"

export default function Activity() {
  const { activitiesdata, userdata } = useSelector((s: any) => s.UserReducer)

  const logs = activitiesdata?.data || []
  const storeId = userdata.store?._id

  const dispatch = useDispatch();
  
  useEffect(() => {
    if (storeId) {
      dispatch(getActivitiesData(storeId, 1, 30))
    }
  }, [storeId])

console.log({activitiesdata});

  return (
    <div className="space-y-8">

      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-800">
          Historique des actions
        </h1>
        <p className="text-sm text-gray-500">
          Traçabilité complète des opérations effectuées
        </p>
      </div>

      {/* Timeline container */}
      <div className="bg-white rounded-2xl shadow-sm border p-6">
        <div className="relative space-y-8">

          {/* Vertical line */}
          <div className="absolute left-5 top-0 bottom-0 w-px bg-gray-200" />

          {logs.map((log: any) => (
            <div key={log._id} className="relative flex gap-6">

              {/* Icon */}
              <div className="relative z-10">
                <ActionIcon type={log.action} />
              </div>

              {/* Card */}
              <div className="flex-1 bg-gray-50 rounded-xl p-4 border hover:bg-gray-100 transition">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">

                  {/* Main text */}
                  <p className="text-sm text-gray-800">
                    <span className="font-semibold">{log.userName}</span>{" "}
                    <span className="text-gray-600">{log.description}</span>
                  </p>

                  {/* Role badge */}
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium w-fit ${log.role === "ADMIN"
                        ? "bg-purple-100 text-purple-700"
                        : "bg-blue-100 text-blue-700"
                      }`}
                  >
                    {log.role}
                  </span>
                </div>

                {/* Meta */}
                <div className="flex items-center gap-4 text-xs text-gray-500 mt-2">
                  <span className="flex items-center gap-1">
                    <User size={12} />
                    Utilisateur
                  </span>

                  <span className="flex items-center gap-1">
                    <Clock size={12} />
                    {new Date(log.createdAt).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          ))}

          {logs.length === 0 && (
            <div className="text-center py-10 text-gray-500">
              Aucune action enregistrée
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

/* ---------- ACTION ICON ---------- */

function ActionIcon({ type }: { type: string }) {
  const base =
    "h-10 w-10 rounded-xl flex items-center justify-center text-white shadow"

  switch (type) {
    case "AJOUT_TELEPHONE":
      return (
        <div className={`${base} bg-blue-600`}>
          <Smartphone size={18} />
        </div>
      )
    case "VENTE":
      return (
        <div className={`${base} bg-green-600`}>
          <ShoppingCart size={18} />
        </div>
      )
    case "PAIEMENT":
      return (
        <div className={`${base} bg-emerald-600`}>
          <DollarSign size={18} />
        </div>
      )
    case "AJOUT_DEPENSE":
      return (
        <div className={`${base} bg-red-600`}>
          <TrendingDown size={18} />
        </div>
      )
    case "UTILISATEUR":
      return (
        <div className={`${base} bg-purple-600`}>
          <UserCog size={18} />
        </div>
      )
    default:
      return (
        <div className={`${base} bg-gray-500`}>
          <Clock size={18} />
        </div>
      )
  }
}
